<template>
  <v-sheet class="pa-4">
    <v-progress-circular v-if="loading_stadions" indeterminate size="64"></v-progress-circular>

    <div class="d-flex flex-wrap">
      <v-card
        v-for="stadion in stadions"
        :key="stadion.id"
        class="ma-2"
        width="300"
      >
        <v-card-text>
          <div v-if="editingId === stadion.id">
            <v-text-field
              v-model="editName"
              label="Stadion Name"
              dense
              @keyup.enter="saveEdit(stadion)"
              @keyup.esc="cancelEdit"
            ></v-text-field>
          </div>
          <div v-else class="text-h6">
            {{ stadion.name }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn
            v-if="editingId === stadion.id"
            text
            color="primary"
            @click="saveEdit(stadion)"
          >
            Save
          </v-btn>
          <v-btn
            v-if="editingId === stadion.id"
            text
            @click="cancelEdit"
          >
            Cancel
          </v-btn>
          <v-btn
            v-if="editingId !== stadion.id"
            text
            color="primary"
            @click="startEdit(stadion)"
          >
            Edit
          </v-btn>
          <v-btn
            text
            color="error"
            @click="confirmDelete(stadion)"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>

    <v-dialog v-model="deleteDialog" max-width="300">
      <v-card>
        <v-card-title>Delete Stadion</v-card-title>
        <v-card-text>
          Are you sure you want to delete this stadion?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn
            color="error"
            text
            @click="deleteStadionConfirmed"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      timeout="3000"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'StadionList',

  data() {
    return {
      editingId: null,
      editName: '',
      deleteDialog: false,
      stadionToDelete: null,
      snackbar: {
        show: false,
        text: '',
        color: 'success'
      }
    };
  },

  created() {
    this.initStadions(this.$route.params.league_id);
  },

  methods: {
    ...mapActions('admin', [
      'initStadions',
      'updateStadion',
      'deleteStadion'
    ]),

    startEdit(stadion) {
      this.editingId = stadion.id;
      this.editName = stadion.name;
    },

    cancelEdit() {
      this.editingId = null;
      this.editName = '';
    },

    async saveEdit(stadion) {
      try {
        await this.updateStadion({
          id: stadion.id,
          name: this.editName
        });
        this.showSnackbar('Stadion updated successfully', 'success');
        this.cancelEdit();
      } catch (error) {
        this.showSnackbar('Failed to update stadion', 'error');
      }
    },

    confirmDelete(stadion) {
      this.stadionToDelete = stadion;
      this.deleteDialog = true;
    },

    async deleteStadionConfirmed() {
      try {
        await this.deleteStadion(this.stadionToDelete.id);
        this.showSnackbar('Stadion deleted successfully', 'success');
      } catch (error) {
        this.showSnackbar('Failed to delete stadion', 'error');
      }
      this.deleteDialog = false;
      this.stadionToDelete = null;
    },

    showSnackbar(text, color) {
      this.snackbar = {
        show: true,
        text,
        color
      };
    }
  },

  computed: {
    ...mapGetters('admin', [
      'stadions',
      'loading_stadions'
    ])
  }
};
</script>